import {useMutation} from '@apollo/client';
import {UPDATE_USER} from "../userTypeDefs";

export const useMutationUpdateUser = (options?: any): any => (
  useMutation(UPDATE_USER, options)
);
